import {webComponentRefreshConstants} from "../../../../constants/Web/webComponentRefresh.constants";

// Proje zarfi: { status: 200, error: false, message, data }
// HTTP 200 donse bile error:true olabilir; basari bu bayrakla anlasilir.
const isOk = (payload) => !!payload && payload.error === false;

// Yanit: data.results.<type>.data
const resultOf = (payload, type) => {
    const results = payload && payload.data && payload.data.results;
    const entry = results && results[type];
    return (entry && entry.data) || null;
};

const initialState = {
    mapFetching: false,
    mapData: null,
    mapError: false,

    reviewFetching: false,
    reviewData: null,
    reviewError: false,
};

export default function (state = initialState, action) {
    switch (action.type) {

        // --- Harita görseli yenileme ---
        case webComponentRefreshConstants.WEB_MAP_REFRESH_PENDING:
            return {
                ...state,
                mapFetching: true,
                mapData: null,
                mapError: false,
            };
        case webComponentRefreshConstants.WEB_MAP_REFRESH_FULFILLED:
            if (!isOk(action.payload)) {
                return {...state, mapFetching: false, mapData: null, mapError: action.payload};
            }
            return {
                ...state,
                mapFetching: false,
                mapError: false,
                // data.results.map.data.images
                mapData: resultOf(action.payload, 'map') || {},
            };
        case webComponentRefreshConstants.WEB_MAP_REFRESH_REJECTED:
            return {
                ...state,
                mapFetching: false,
                mapError: action.payload,
            };

        // --- Google yorumlarını yenileme ---
        case webComponentRefreshConstants.WEB_REVIEW_REFRESH_PENDING:
            return {
                ...state,
                reviewFetching: true,
                reviewData: null,
                reviewError: false,
            };
        case webComponentRefreshConstants.WEB_REVIEW_REFRESH_FULFILLED:
            if (!isOk(action.payload)) {
                return {...state, reviewFetching: false, reviewData: null, reviewError: action.payload};
            }
            return {
                ...state,
                reviewFetching: false,
                reviewError: false,
                // data.results.review.data = {added, total, google_rating, google_rating_total}
                reviewData: resultOf(action.payload, 'review') || {},
            };
        case webComponentRefreshConstants.WEB_REVIEW_REFRESH_REJECTED:
            return {
                ...state,
                reviewFetching: false,
                reviewError: action.payload,
            };

        case webComponentRefreshConstants.WEB_COMPONENT_REFRESH_CLEAR:
            return {
                ...initialState,
            };

        default:
            return state;
    }
}
